<template>
  <div class="card-store">
    <div class="card-store-content">
      <div class="card-block card-store-content__title">
        <div class="wrapp-icon">
           <svg class="o-icon"><use xlink:href="#pin"></use></svg>
        </div>
        <div class="wrapp-text">
          <h6 class="title">{{address}}</h6>
          <div class="phone-number">
            <span class="text">{{store.phone_number}}</span>
          </div>
        </div>
        <div class="wrapp-stock" :class="[(store.stock_status ? 'in-stock' : 'not-in-stock')]">
          <svg class="o-icon">
            <use xlink:href="#check" v-if="store.stock_status"></use>
            <use xlink:href="#close" v-else></use>
          </svg>
          <span class="text">{{stockStatus}}</span>
        </div>
      </div>
      <div class="card-block card-store-content__ctas">
        <button class="btn btn-icon" v-b-toggle="'accordion-' + store.code">
          <div class="wrapp-distance" v-if="distance">
            <svg class="o-icon"><use xlink:href="#map-pin-2-line"></use></svg>
            <span class="text">{{distance}}</span>
          </div>
          <div class="wrapp-time">
            <svg class="o-icon"><use xlink:href="#clock"></use></svg>
            <span class="text">{{ $t('time') }}</span>
          </div>
        </button>
        <router-link :to="{ name: 'Boutique', params: { store_code: store.code }, query: { 'wasPDP': true } }"  class="bcm-link t-small">{{ $t('view-detail') }}</router-link>
      </div>
      <div class="card-block card-store-content__working-hours" v-if="store.working_hours">
        <b-collapse :id="'accordion-' + store.code" class="mt-2">
          <div class="wh-list" v-for="(wh, index) in store.working_hours" :key="index">
            <span class="label">{{index}} </span>
            <span class="wh">{{wh.  from}} - {{wh.to}}</span>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardBoutique',
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  computed: {
    address () {
      return `${this.store.address}, ${this.store.city}, ${this.store.region} – ${this.store.country}`
    },
    stockStatus () {
      return this.store && this.store.stock_status ? this.$t('IN_STOCK') : this.$t('OUT_OF_STOCK')
    },
    distance () {
      if (this.store && this.store.distance) {
        return `${parseInt(this.store.distance)} km`
      } else {
        return false
      }
    }
  }
}
</script>
